import { useEffect, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { login, logout } from '../actions/auth';
import api from '../api';
import notifSystem from '../notifSystem';

const getUrl = (pathname) => (
  pathname !== '/login' ? pathname : ''
);

const TokenManager = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth || {});

  const url = useMemo(
    () => getUrl(location.pathname),
    [location.pathname]
  );

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  /**
   * Request to check if token is valid
   * @param {String} token - token number taken from query
   */
  const getTokenRequest = useCallback(
    (token) => api.login.custom('verifToken').post({ token }),
    []
  );

  const processToken = useCallback(async () => {
    try {
      const token = query.get('token');

      if (!token) {
        return false;
      }
      let data;
      if (auth.token) {
        data = auth;
      } else {
        const response = await getTokenRequest(token);
        data = response.body().data();
      }
      if (!data?.token) {
        return false;
      }

      if (!auth.token) {
        dispatch(login(data.token));
      }

      const redirectState = { isFromExternalLink: true };
      navigate(url || '/', { state: redirectState });
      return true;
    } catch (error) {
      navigate('/');
      dispatch(logout());
      return notifSystem.error(
        'Erreur',
        error.response?.data || 'Echec de connexion'
      );
    }
  }, [query, getTokenRequest, auth, navigate, url, dispatch]);

  useEffect(() => {
    processToken();
  }, [processToken]);

  return null;
};

export default TokenManager;
